import { INewbuildingForDeveloperCardSchema } from '../repositories/newbuilding-search/entities/newbuilding_for_developer_card/NewbuildingForDeveloperCardSchema';
import { INewBuilding, INewbuildingCount } from '../types/newBuldings';
import { INewbuildingCountSchema } from '../repositories/newbuilding-search/entities/get_newbuildings_for_developer_card/NewbuildingCountSchema';

export function newbuildingMapper(newbuilding: INewbuildingForDeveloperCardSchema): INewBuilding {
  return {
    additionalImages: newbuilding.additionalImages,
    address: newbuilding.address,
    coordinates: newbuilding.coordinates,
    finishLabel: newbuilding.finishLabel,
    flatStats: newbuilding.flatStats,
    id: newbuilding.id,
    image: newbuilding.image,
    isReliable: newbuilding.isReliable,
    labels: newbuilding.labels,
    promoList: newbuilding.promoList,
    publicUrl: newbuilding.publicUrl,
    searchList: newbuilding.searchList,
    subwayInfo: newbuilding.subwayInfo,
    title: newbuilding.title,
    phoneNumber: newbuilding.phoneNumber,
    isKpn: newbuilding.isKpn,
  };
}

export function newbuildingCountsMapper(counts: INewbuildingCountSchema[]): INewbuildingCount[] {
  return counts.map(item => ({
    displayName: item.displayName,
    count: item.count,
    newbuildingStatus: item.newbuildingStatus,
  }));
}
